import { render, staticRenderFns } from "./TableTopTen.vue?vue&type=template&id=8e23a6ac&scoped=true&"
import script from "./TableTopTen.vue?vue&type=script&lang=js&"
export * from "./TableTopTen.vue?vue&type=script&lang=js&"
import style0 from "./TableTopTen.vue?vue&type=style&index=0&id=8e23a6ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e23a6ac",
  null
  
)

export default component.exports